// Normalizes an axios/FastAPI error into a human-readable string.
// FastAPI returns `detail` as a string for HTTPException, but as an array of
// {loc, msg, type} objects for 422 validation errors. Rendering that array
// directly in JSX crashes React (error #31 / white screen), so always run
// server errors through this before putting them in state.
export function parseApiError(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((d) => {
      if (typeof d === 'string') return d;
      const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : '';
      return field ? `${field}: ${d?.msg}` : d?.msg;
    }).filter(Boolean);
    return parts.join('; ') || fallback;
  }
  if (typeof detail === 'object') return detail.msg || fallback;
  return fallback;
}
